module.exports = __webpack_public_path__ + "static/media/Trade Gothic-01.e7175a1d.svg";